// extracted by mini-css-extract-plugin
export default {"products":"wu-z","card":"xu-z","oosMessaging":"yu-z"};